import React, { useEffect, useState } from 'react';
import { api } from '../api';

export default function CityInput({ iso3, value, onChange, className, testid = 'trip-city' }) {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    if (!iso3 || (value || '').trim().length < 2) { setOpts([]); return undefined; }
    const h = setTimeout(() => { api.get('/travel/cities', { params: { q: value, iso3 } }).then((r) => setOpts(r.data)).catch(() => setOpts([])); }, 300);
    return () => clearTimeout(h);
  }, [iso3, value]);
  return (
    <>
      <input required value={value} onChange={(e) => onChange(e.target.value)} list={`${testid}-list`} disabled={!iso3} autoComplete="off"
        placeholder={iso3 ? 'Città di destinazione' : 'Città (scegli prima il Paese)'} className={className} data-testid={testid} />
      <datalist id={`${testid}-list`}>{opts.map((o) => <option key={o.label + o.admins.join()} value={o.label} />)}</datalist>
    </>
  );
}
